import { useEffect } from "react";

import Quill from "quill";

// Quill preventDefaults copy/cut before checking that the DOM selection maps
// onto a Quill range, so a selection spilling past `.ql-editor` copies nothing.
export const useClampSelectionToEditor = (
  quill: React.RefObject<Nullable<Quill>>,
) => {
  useEffect(() => {
    const container = quill.current?.container;
    if (!container) return;

    const clampSelection = () => {
      const editor = quill.current;
      const selection = document.getSelection();
      if (!editor || !selection || editor.getSelection()) return;
      if (!selection.containsNode(editor.root, true)) return;

      const { startContainer, startOffset, endContainer, endOffset } =
        selection.getRangeAt(0);
      const clamped = document.createRange();
      clamped.selectNodeContents(editor.root);
      if (editor.root.contains(startContainer)) {
        clamped.setStart(startContainer, startOffset);
      }
      if (editor.root.contains(endContainer)) {
        clamped.setEnd(endContainer, endOffset);
      }

      selection.removeAllRanges();
      selection.addRange(clamped);
    };

    container.addEventListener("copy", clampSelection, true);
    container.addEventListener("cut", clampSelection, true);
    return () => {
      container.removeEventListener("copy", clampSelection, true);
      container.removeEventListener("cut", clampSelection, true);
    };
  }, [quill]);
};
